import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import getCoreNavigationStore from "../stores/core/core-navigation-store";
import getCorePersonalStore from "../stores/core/core-personal-store";
import getCoreUIStore from "../stores/core/core-ui-store";
import ET3Div from "../core/et3-div";
import { withLiteObserverAndTheme } from "../core/et3-enhanced-render";
import { TEt3Theme } from "../core/et3-theme";
import BlockerPages from "./blocker";
import KhattabatLoadingBackdrop from "../core/et3-loading/KhattabatLoadingBackdrop";
import Et3NoPermission from "../core/et3-no-permission";
import Header from "./header";
import ET3DivRef from "../core/et3-div-ref";
import SideBar from "./side-bar";
import KhattabatAlertDialog from "../core/et3-pop-up-alerts/KhattabatAlertDialog";
import Et3ConfirmationPopUp from "../core/et3-pop-up-confirmation";
import Et3ActionPopUp from "../core/et3-pop-up-actions";
import Et3TBWPopUp from "../core/et3-pop-up-tbw";
import KhattabatBackToTop from "../core/et3-back-to-top/KhattabatBackToTop";
import { isPositiveNumber } from "et3-type-guards";
import Login from "../routes/login";

const PageWrapper = withLiteObserverAndTheme<{
  Page: React.ComponentType<{
    theme?: TEt3Theme;
  }>;
  isBlocker: boolean;
}>((props) => {
  const { Page, isBlocker, theme } = props;
  const { colors } = theme;
  const adminServiceIsActive = getCorePersonalStore().adminServiceIsActive();
  const shouldShowPage = adminServiceIsActive;
  const sideBarVisible = getCoreUIStore().shouldShowSideBar.get();
  const mainWidth = sideBarVisible ? 1620 : 1920;
  const et3PageDivRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    getCoreNavigationStore().setNavigate(navigate);
  }, [navigate]);
  const isDefinedAdminId = isPositiveNumber(
    getCorePersonalStore().user.get().id
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1920}
      height={1230}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{ overflowX: "clip", height: "100dvh", minHeight: 0 }}
      onClick={() => {}}
    >
      <KhattabatAlertDialog />
      <Et3ActionPopUp />
      {isDefinedAdminId ? (
        <React.Fragment>
          <BlockerPages />
          <KhattabatLoadingBackdrop />
          <Et3NoPermission />
          <Header />
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={1920}
            height={1110}
            fDirection="row"
            alignItems="stretch"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{ flex: 1, minHeight: 0 }}
            onClick={() => {}}
          >
            <SideBar />
            <ET3DivRef
              isScrollable={true}
              isExtendable={false}
              withShadow={false}
              width={mainWidth}
              height={1110}
              fDirection="column"
              alignItems="flex-start"
              justifyContent="flex-start"
              color={colors.all.transparent}
              style={{ overflowX: "clip", height: "auto", minHeight: 0 }}
              onClick={() => {}}
              refDiv={et3PageDivRef}
            >
              <Et3ConfirmationPopUp />
              <Et3TBWPopUp />
              {isBlocker ? (
                !shouldShowPage ? (
                  <BlockerPages />
                ) : null
              ) : !shouldShowPage ? null : (
                <Page />
              )}
              <KhattabatBackToTop refDiv={et3PageDivRef} />
            </ET3DivRef>
          </ET3Div>
        </React.Fragment>
      ) : (
        <Login />
      )}
    </ET3Div>
  );
});
export default PageWrapper;
